import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import IntlMessages from 'util/IntlMessages';
import CircularProgress from "@material-ui/core/CircularProgress";
import BBLogo from "../assets/images/BreachBits_full_medres_transparent_fordarkbackground.png"

import {
  confirmEmailAction, confirmEmailSetInitialValues,
  showAuthLoader,
} from 'actions/Auth';
import {showBBNotification} from "../util/bbHelpers";
import {INFO} from "../constants/ActionTypes";
import qs from 'qs';
import {useForm} from "react-hook-form";

var pjson = require('../../package.json'); //to display version number

const ConfirmEmail = (props) => {

  const dispatch = useDispatch();
  const {token, authUser} = useSelector(({auth}) => auth);
  const {didJustEmailConfirmCode} = useSelector(({auth}) => auth.appMisc);
  const {loader} = useSelector(({auth}) => auth);

  //variables grabbed form the URL parameters
  const {match, location} = props;
  const urlCode = location.search ? qs.parse(location.search, { ignoreQueryPrefix: true }).code : null;
  const [confirmationCode, setConfirmationCode] = useState(urlCode ? urlCode : null);

  //form validation
  const { register, handleSubmit, errors } = useForm();
  const onSubmit = data => {
    dispatch(showAuthLoader());
    dispatch(confirmEmailAction({"confirmationCode": data.codeInput}));
  }

  //stop the page loader
  // useState(nprogress.start());

  useEffect(() => {
    // nprogress.done();

    // console.log("TOKEN CHECK. TOKEN IS", token, "local:", localStorage.getItem("token"));
    console.log("Loading confirm email page. Match:", match, "Location:", location, "props", props);
    console.log("Parsing for the confirmation code:", urlCode)
    //if there is a token set (if user is logged in), redirect to home page
    //TODO: Update to leverage refresh_token instead
    // if (token != null && authUser && authUser.user.is_activated) {
    //   props.history.push('/');
    // }

    if (authUser && !authUser.user.is_activated){
      showBBNotification(INFO,
          <IntlMessages id={"event.userInactive.title"}/>,
          <IntlMessages id={"event.userInactive.detail"}/>,
          true);
    }

    //if the confirm code didn't work, it will be set to false
    if (didJustEmailConfirmCode != null && didJustEmailConfirmCode === false){
      showBBNotification(INFO,
          <IntlMessages id={"event.wrongConfirmCode.title"}/>,
          <IntlMessages id={"event.wrongConfirmCode.detail"}/>,
          false);
    }

    //if the confirm code state has been set to success, redirect to login page
    if (didJustEmailConfirmCode) {
      dispatch(confirmEmailSetInitialValues()); //reset the state to default confirm email state
      props.history.push('/signin');
    }
    // return () => nprogress.start();

  }, [props.history, dispatch, authUser, errors, didJustEmailConfirmCode]);

  return (
      <React.Fragment>
    <div
      className="app-login-container d-flex justify-content-center align-items-center animated fadeIn animation-duration-15">
      <div className="app-login-main-content">


          <div className="app-logo-content d-flex align-items-center justify-content-center">
            <a className="logo-lg" href="https://www.breachbits.com" title="BreachBits">
              <img src={BBLogo} alt="BreachBits Logo" title="Learn more about BreachBits at breachbits.com"/>
            </a>
          </div>



        <div className="app-login-content">
          <div className="app-login-header mb-4">
            <h1><IntlMessages id="appModule.confirm"/></h1>
            <h4><IntlMessages id="appModule.confirm.details"/></h4>
          </div>

          <div className="app-confirm-form">
            <form>
              <fieldset>
                {/*<TextField*/}
                {/*  label={<IntlMessages id="appModule.username"/>}*/}
                {/*  fullWidth*/}
                {/*  onChange={(event) => setEmail(event.target.value)}*/}
                {/*  defaultValue={email}*/}
                {/*  margin="normal"*/}
                {/*  className="mt-1 my-sm-3"*/}
                {/*/>*/}
                <TextField
                  label={<IntlMessages id="appModule.confirmCode"/>}
                  fullWidth
                  id="codeInput"
                  name="codeInput"
                  required
                  error={!!errors.codeInput}
                  onChange={(event) => setConfirmationCode(event.target.value)}
                  defaultValue={urlCode}
                  margin="normal"
                  className="mt-1 my-sm-3"
                  inputRef={register({
                    required: "This field is required." ,

                  })}
                  helperText={errors.codeInput?.message}
                />

                <div className="mb-3 d-flex align-items-center justify-content-between">
                  <Button onClick={handleSubmit(onSubmit)}
                          disabled={!!errors.codeInput }
                          variant="contained" color="primary">
                    <IntlMessages id="form.submit"/>
                  </Button>
                  {/*<Button onClick={() => {*/}
                  {/*  dispatch(showAuthLoader());*/}
                  {/*  dispatch(confirmEmailAction({confirmationCode}));*/}
                  {/*}} variant="contained" color="primary">*/}
                  {/*  <IntlMessages id="form.submit"/>*/}
                  {/*</Button>*/}

                  {token && //If user is logged in, they can go back to the dashboard.
                  <Link to="/board/dashboard">
                    <IntlMessages id="form.goBackHome"/>
                  </Link>
                  }
                  {!token && //If user is not logged in, they can go back to the signin.
                  <Link to="/signin">
                    <IntlMessages id="form.goSignIn"/>
                  </Link>
                  }
                </div>

              </fieldset>
            </form>
          </div>
          <div id={"version"}> v. {`${pjson.version}`}</div>
        </div>

      </div>


      {
        loader &&
        <div className="loader-view">
          <CircularProgress/>
        </div>
      }
      {/*{showMessage && NotificationManager.error(alertMessage, "Login Error", 10000)}*/}
      {/*<NotificationContainer/>*/}

    </div>
        <div className="break"> </div>
        {/*<div className={"app-login-subtitle"}>*/}
        {/*  <img src={require("assets/images/turn-the-tide-dark.png")} alt="breachbits" title="breachbits"/>*/}
        {/*</div>*/}
      </React.Fragment>
  );
};


export default ConfirmEmail;
